import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  background: '#0a0a0a',
  color: '#fff',
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  }
});

export const showAlert = (title, text, icon = 'info') => {
  return Swal.fire({
    title,
    text,
    icon,
    background: '#0a0a0a',
    color: '#fff',
    confirmButtonColor: '#d4af37',
    customClass: {
      popup: 'luxury-card border border-white/10 rounded-3xl',
      title: 'text-white font-serif',
      htmlContainer: 'text-[#707070]',
      confirmButton: 'luxury-button !py-3 !px-8 rounded-xl'
    }
  });
};

export const showSuccess = (title, text) => {
  return showAlert(title, text, 'success');
};

export const showError = (title, text) => {
  return showAlert(title, text, 'error');
};

export const showToast = (title, icon = 'success') => {
  return Toast.fire({
    icon,
    title
  });
};
